import Grid from '@mui/material/Grid';
import PointsDataTable from '../elements/PointsDataTable';
import SliderFilterPopover, { SliderOptions } from '../elements/filter/SliderFilterPopover';
import TextFilterPopover from '../elements/filter/TextFilterPopover';
import PointTypeFilterPopover from '../elements/filter/PointTypeFilterPopover';
import StagingFilterBuilder, { FilterDefinition } from '../elements/StagingFilterBuilder';
import UnitsLoader from '../../loaders/UnitsLoader';
import PointTypeLoader from '../../loaders/PointTypeLoader';
import EquipTypeLoader from '../../loaders/EquipTypeLoader';
import { PointTypeFilter, ContainsTextFilter, RangeFilter } from '../../../redux/constants/filters'; // ContainsStatusFilter
// import MultiSelectPopover from '../elements/filter/MultiSelectPopover';

const filterDefs = [
  new FilterDefinition(
    PointTypeFilterPopover,
    'point_type',
    'Point Type',
    {},
    (type) =>
      new PointTypeFilter({
        key: 'point_type',
        getter: (d) => d.point_type_id,
        type,
      }),
    (type) => type.name
  ),
  // new FilterDefinition(
  //   MultiSelectPopover,
  //   'status',
  //   'Status',
  //   [
  //     { id: 'promoted', label: 'Promoted'},
  //     { id: 'unpromoted', label: 'Unpromoted'},
  //     { id: 'promotion_error', label: 'Validation Error'},
  //     { id: 'changes', label: 'Unpromoted Changes'},
  //   ],
  //   (v) => new ContainsStatusFilter({ key: 'pointName', getter: (d) => d.data.name, fragment: v })
  // ),
  new FilterDefinition(
    SliderFilterPopover,
    'pointConfidence',
    'Confidence',
    new SliderOptions([0, 100], [50, 100]),
    (v) =>
      new RangeFilter({
        key: 'pointConfidence',
        getter: (point) => Math.round(point.confidences.point_type),
        minimum: v[0],
        maximum: v[1],
      })
  ),
  new FilterDefinition(
    TextFilterPopover,
    'pointName',
    'Point Name',
    {},
    (v) => new ContainsTextFilter({ key: 'pointName', getter: (d) => d.data.name, fragment: v })
  ),
  new FilterDefinition(
    TextFilterPopover,
    'pointDescription',
    'Description',
    {},
    (v) =>
      new ContainsTextFilter({
        key: 'pointDescription',
        getter: (d) => d.data.description,
        fragment: v,
      })
  ),
  new FilterDefinition(
    TextFilterPopover,
    'equip_id',
    'Equip ID',
    {},
    (v) => new ContainsTextFilter({ key: 'equip_id', getter: (d) => d.equip_id, fragment: v })
  ),
];

const PointsView = ({ buildingId }) => (
  <>
    <Grid item xs={12}>
      <StagingFilterBuilder filterDefs={filterDefs} />
    </Grid>
    <Grid item xs={12}>
      <UnitsLoader />
      <PointTypeLoader />
      <EquipTypeLoader />
      <PointsDataTable buildingId={buildingId} />
    </Grid>
  </>
);

export default PointsView;
